export default {
  name: 'ECBSVModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    memberId: {
      type: Number
    },
    localFormPolicies: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ecbsvFormPolicies: this.localFormPolicies
    };
  },
  computed: {},
  watch: {
    show: 'ecbsvScreenViewed'
  },
  methods: {
    handleCheckboxChange(event) {
      this.$emit('checkbox-changed', event.target.checked);
    },
    ecbsvScreenViewed() {
      if (this.show) {
        this.$analyticsHub.track(`funnel.eCBSV_Agreement_Viewed`, {
          member_id: this.memberId
        });
      }
    }
  }
};